module.exports = __webpack_public_path__ + "static/media/deck.721593dc.svg";